import type { Film, FilmCategory } from "@/types";
import { films } from "./films";

export interface CategoryMeta {
  key: FilmCategory;
  name: string;
  icon: string;
  description: string;
  cover: string;
}

export const categories: CategoryMeta[] = [
  {
    key: "电影",
    name: "电影",
    icon: "ri-film-line",
    description: "院线大片与艺术佳作，两天一晚的沉浸式光影体验",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20minimal%20illustration%20of%20a%20glowing%20cinema%20screen%20in%20a%20dark%20auditorium%20with%20warm%20amber%20light%20rays%2C%20deep%20navy%20and%20soft%20gold%20tones%2C%20clean%20composition%2C%20no%20text&width=600&height=400&seq=cat-cover-01&orientation=landscape",
  },
  {
    key: "电视剧",
    name: "电视剧",
    icon: "ri-tv-2-line",
    description: "都市情感与多元题材，陪你度过每一个追剧的夜晚",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20minimal%20illustration%20of%20a%20television%20screen%20glowing%20in%20a%20cozy%20dark%20room%20with%20warm%20amber%20accent%20light%2C%20deep%20teal%20and%20soft%20gold%20tones%2C%20clean%20composition%2C%20no%20text&width=600&height=400&seq=cat-cover-02&orientation=landscape",
  },
  {
    key: "国产剧",
    name: "国产剧",
    icon: "ri-live-line",
    description: "古装权谋与现实题材，记录属于这片土地的故事",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20minimal%20illustration%20of%20an%20ancient%20Chinese%20rooftop%20silhouette%20with%20warm%20lanterns%20under%20a%20dusk%20sky%2C%20ink%20crimson%20and%20gold%20tones%2C%20clean%20elegant%20composition%2C%20no%20text&width=600&height=400&seq=cat-cover-03&orientation=landscape",
  },
  {
    key: "海外剧",
    name: "海外剧",
    icon: "ri-earth-line",
    description: "来自世界各地的优质剧集，品味不一样的城市与人生",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20minimal%20illustration%20of%20a%20world%20globe%20outline%20with%20soft%20city%20lights%20and%20a%20warm%20sunset%20gradient%2C%20cool%20blue%20and%20soft%20amber%20tones%2C%20clean%20compositions%2C%20no%20text&width=600&height=400&seq=cat-cover-04&orientation=landscape",
  },
];

export function getFilmsByCategory(category: FilmCategory): Film[] {
  return films.filter((f) => f.category === category);
}